import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";

const cities = ["Delhi", "Mumbai", "Bangalore", "Pune", "Jaipur", "Hyderabad", "Chennai", "Kolkata", "Lucknow", "Ahmedabad", "Chandigarh", "Indore"];
const names = ["Rahul", "Priya", "Amit", "Neha", "Vikram", "Anjali", "Arjun", "Pooja", "Karan", "Simran", "Rohan", "Divya", "Chirag", "Meera"];
const actions = [
  { en: "unlocked their report", hi: "ने रिपोर्ट अनलॉक की" },
  { en: "just completed their reading", hi: "ने अभी रीडिंग पूरी की" },
  { en: "started a live session", hi: "ने लाइव सेशन शुरू किया" },
];
const times = ["just now", "1 min ago", "2 min ago", "3 min ago", "5 min ago"];

export function SocialProofToast({ language = "en" }) {
  const [notification, setNotification] = useState(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const show = () => {
      const name = names[Math.floor(Math.random() * names.length)];
      const city = cities[Math.floor(Math.random() * cities.length)];
      const action = actions[Math.floor(Math.random() * actions.length)];
      const time = times[Math.floor(Math.random() * times.length)];
      setNotification({ name, city, action: language === "hi" ? action.hi : action.en, time });
      setVisible(true);
      setTimeout(() => setVisible(false), 4000);
    };

    const initialDelay = setTimeout(show, 8000);
    const interval = setInterval(show, 18000 + Math.random() * 12000);
    return () => { clearTimeout(initialDelay); clearInterval(interval); };
  }, [language]);

  return (
    <AnimatePresence>
      {visible && notification && (
        <motion.div
          initial={{ opacity: 0, x: -100, y: 20 }}
          animate={{ opacity: 1, x: 0, y: 0 }}
          exit={{ opacity: 0, x: -100 }}
          transition={{ type: "spring", stiffness: 300, damping: 25 }}
          className="fixed bottom-24 md:bottom-8 left-4 z-40 max-w-xs"
          data-testid="social-proof-toast"
        >
          <div className="bg-white/95 backdrop-blur-xl rounded-2xl px-4 py-3 shadow-lg border border-gray-100 flex items-center gap-3">
            <div className="w-9 h-9 rounded-full bg-gradient-to-br from-amber-400 to-amber-600 flex items-center justify-center text-white text-xs font-bold flex-shrink-0">
              {notification.name[0]}
            </div>
            <div className="min-w-0">
              <p className="text-xs font-semibold text-gray-900 truncate">
                {notification.name} <span className="font-normal text-gray-400">from {notification.city}</span>
              </p>
              <p className="text-[11px] text-gray-500">{notification.action} · {notification.time}</p>
            </div>
            <div className="w-2 h-2 rounded-full bg-green-400 flex-shrink-0 animate-pulse" />
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}

export function CountdownTimer() {
  const [time, setTime] = useState(() => {
    const stored = sessionStorage.getItem("va_countdown");
    if (stored) {
      const remaining = Math.max(0, parseInt(stored) - Math.floor(Date.now() / 1000));
      return remaining > 0 ? remaining : 15 * 60;
    }
    const end = Math.floor(Date.now() / 1000) + 15 * 60;
    sessionStorage.setItem("va_countdown", String(end));
    return 15 * 60;
  });

  useEffect(() => {
    const tick = setInterval(() => {
      setTime(prev => {
        if (prev <= 1) {
          const end = Math.floor(Date.now() / 1000) + 15 * 60;
          sessionStorage.setItem("va_countdown", String(end));
          return 15 * 60;
        }
        return prev - 1;
      });
    }, 1000);
    return () => clearInterval(tick);
  }, []);

  const m = String(Math.floor(time / 60)).padStart(2, "0");
  const s = String(time % 60).padStart(2, "0");

  return (
    <div className="flex items-center justify-center gap-1.5 text-sm font-bold" data-testid="countdown-timer">
      <span className="text-red-500">⏰</span>
      <span className="text-gray-500 text-xs font-medium">Offer ends in</span>
      <span className="countdown-digit">{m[0]}</span>
      <span className="countdown-digit">{m[1]}</span>
      <span className="text-amber-500 font-bold">:</span>
      <span className="countdown-digit">{s[0]}</span>
      <span className="countdown-digit">{s[1]}</span>
    </div>
  );
}
